"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routeReturnPath = void 0;
var routeReturnPath = function (routeInfo) {
  if (routeInfo === void 0) {
    routeInfo = '';
  }
  var matches = routeInfo.match(/from(\/.+)/);
  if (matches && matches.length === 2) {
    return matches[1];
  }
  return '';
};
exports.routeReturnPath = routeReturnPath;